/* eslint-disable no-console */
import { report, isInExoSkeleton, REPORT_TYPES, TReportType } from '@adsk/exo-skeleton-api';
import { ErrorInfo } from 'react';
import { getEnv, ENVS } from '@adsk/acs-sc-web-platform-api';

const META = {
  isAccRfis: true,
};

const consoleStyledPrefix = {
  [REPORT_TYPES.info]: ['%c RFIs INFO: ', 'background: #006eaf; font-weight: bold; color: #FFF'],
  [REPORT_TYPES.error]: ['%c RFIs ERROR: ', 'background: #A61A1A; font-weight: bold; color: #FFF'],
};

type StringOrError<T extends 'info' | 'error' | 'warning'> = T extends 'error' ? Error : string;

const reportWrapper =
  <T extends TReportType>(reportType: T) =>
  (value: StringOrError<T>, context: Record<string, unknown> | ErrorInfo = {}) => {
    const rfiLogContext = {
      rfi: {
        meta: {
          ...META,
          reportType,
        },
        context,
      },
    };

    const env = getEnv();
    if (isInExoSkeleton()) {
      // Prepare event_properties for the new report format
      let message: string | undefined;
      let stack: string | undefined;
      if (value instanceof Error) {
        message = value.message;
        stack = value.stack;
      } else {
        message = String(value);
      }

      report({
        scope: 'accRfis',
        context: {
          'event_properties.data': (() => {
            try {
              return JSON.stringify(context);
            } catch {
              return JSON.stringify({ error: 'Error in JSON.stringify so no data was added' });
            }
          })(),
          'event_properties.message': message,
          'event_properties.stack': stack,
          'event_properties.type': reportType,
        },
      });
    }

    if (env !== ENVS.PRODUCTION) {
      const prefix = consoleStyledPrefix[reportType];

      switch (reportType) {
        case REPORT_TYPES.info:
          console.log(...prefix, value, rfiLogContext);
          break;
        case REPORT_TYPES.error:
          console.error(...prefix, value, rfiLogContext);
          break;

        default:
          break;
      }
    }
  };

export const log = {
  info: reportWrapper('info'),
  error: reportWrapper('error'),
};
